<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              Шаблоны назначений платежа
            </div>
            <div class="row mt-3">
              <div class="col-lg-12">
                <table class="table table-hover" style="cursor: pointer;">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Назначения платежа 1</th>
                    <th>Назначения платежа 2</th>
                    <th>Назначения платежа 3</th>
                    <th>Действия</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in this.reasonTemplatesData" :key="item.id">
                    <td>{{item.id}}</td>
                    <td>{{item.text}}</td>
                    <td>{{item.suffix}}</td>
                    <td>{{item.suffix2}}</td>
                    <td>
                      <div @click="selectForUse(item)" class="btn btn-sm btn-outline-success">
                        <i class="fas"></i> Выбрать
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import axios from "axios";

export default {

  name: "SelectOrderReason",
  data() {
    return {
      reasonTemplatesData: null,
      submitted: false
    }
  },
  mounted() {

  },
  props: {
  },
  watch: {
  },
  computed: {
  },
  validations: {
  },
  methods: {
    getReasonData() {
      axios
          .get(`/v1/payment-order-reason-templates/get`)
          .then(resp => {
                this.reasonTemplatesData = resp.data;
              }
          )
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
    selectForUse (selectedReason) {
      this.$emit('event-reason-was-selected', selectedReason);
    }
  },
};
</script>

<style scoped lang="css">

</style>
